import {BrowserRouter, Route, Routes, useLocation} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {CourseListEntry, FirebaseContext} from "./Firebase";
import {User} from 'firebase/auth'
import Home from './Home'
import Course from "./Course"
import Blogs from "./Blogs"
import BlogPost from "./BlogPost"
import {AdministrationPage} from "./AdministrationPage"

export const AppContext = React.createContext<{
    user: User | null
    courses: CourseListEntry[] | null
}>({user: null, courses: null})


// 路由追蹤：SPA 內用 react-router 切換頁面時，gtag 不會自動送 page_view。
// index.html 已設 send_page_view:false，所以這裡負責於每次路由變化（含首次載入）送出 page_view。
// 延後一小段再送：等 react-helmet 更新 document.title 後才讀，否則 page_title 會是預設值。
function RouteTracker() {
    const location = useLocation()
    useEffect(() => {
        const id = window.setTimeout(() => {
            const gtag = (window as any).gtag
            if (typeof gtag === "function") {
                gtag("event", "page_view", {
                    page_path: location.pathname + location.search,
                    page_location: window.location.href,
                    page_title: document.title,
                })
            }
        }, 80)
        return () => window.clearTimeout(id)
    }, [location.pathname, location.search])
    return null
}

function ExternalRedirect(props: any) {
    useEffect(() => {
        window.location.href = props.to
      }, [props.to]);
    
      return null; // 這個組件不需要渲染任何內容
}

const App = () => {
    const [user, setUser] = useState<User|null>(null)
    const [courses, setCourses]  = useState<CourseListEntry[]|null>(null)
    const firebase = useContext(FirebaseContext)

    useEffect(
        () => {
            if (firebase == null) return;
            firebase.auth.onAuthStateChanged((user: any) => {
                setUser(user)
                if (user != null && user.uid != null) {
                    firebase.getCourses().then(courses => {
                        setCourses(courses)
                    }).catch(e => {
                        console.log(e)
                    })
                } else {
                    setCourses(null)
                }
            })
        },
        [firebase]
    )

    return <AppContext.Provider value={{user, courses}}>
        <BrowserRouter>
            <RouteTracker/>
            <Routes>
                <Route path="/vr"
                       element={
                            <ExternalRedirect to="https://hackmd.io/@feislee/SkoCBFjgi" />
                       }/>
                <Route path="/fb"
                       element={
                            <ExternalRedirect to="https://www.facebook.com/feisstudio" />
                       }/>
                <Route path="/courses"
                       element={
                            <ExternalRedirect to="https://train.csie.ntu.edu.tw/train/courses.php?q=%E6%9D%8E%E6%A0%B9%E9%80%B8" />
                       }/>
                <Route path="/yt"
                       element={
                            <ExternalRedirect to="https://www.youtube.com/c/KenYiLee" />
                       }/>
                <Route path="/support"
                       element={
                            <ExternalRedirect to="https://p.ecpay.com.tw/CD9CD" />
                       }/>
                <Route path="/medium"
                        element = {
                            <ExternalRedirect to="https://medium.com/feis-studio" />
                        }/>
                <Route path="/discord"
                        element= {
                            <ExternalRedirect to="https://discordapp.com/invite/FAXhhTt" />
                        }/>
                <Route path="/AdministrationPage"
                    element={
                        <AdministrationPage/>
                    }/>
                <Route path="/blogs"
                    element={
                        <Blogs/>
                    }/>
                <Route path="/blogs/:slug"
                    element={
                        <BlogPost/>
                    }/>
                <Route path="/"
                    element={
                        <Home/>        
                    }/>
                <Route path="/:token"
                    element={
                        <Course/>
                    }/>
                <Route path="/:token/:anchor"
                    element={
                        <Course/>
                    }/>         
            </Routes>
        </BrowserRouter>
    </AppContext.Provider>
}

export default App